import { render } from "./Checker.vue?vue&type=template&id=12b526e6&ts=true&lang=pug"
import script from "./Checker.vue?vue&type=script&lang=ts&setup=true"
export * from "./Checker.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__